import { forwardRef } from 'react';
import type { TypographyProps } from '../types/typography.types';
import { cn } from '@utils';

const CaptionTypography = forwardRef<HTMLHeadingElement, TypographyProps>(
	({ className, children, truncate = true }, ref) => (
		<h4 ref={ref} className={cn(`scroll-m-20 text-xs font-normal ${truncate ? 'truncate' : ''}`, className)}>
			{children}
		</h4>
	)
);

CaptionTypography.displayName = 'CaptionTypography';

export default CaptionTypography;
